module.exports = __webpack_public_path__ + "static/media/jumper.e14051d7.png";